
(function () {
  'use strict';
  if (window.vskloComparePriceFallback) return;
  window.vskloComparePriceFallback = function (root, compareAtPrice, currentPrice) {
    var current = Number(currentPrice || 0);
    var direct = Number(compareAtPrice || 0);
    if (direct && direct > current) return direct;
    if (!root || !root.querySelector) return direct || 0;
    var block = root.querySelector('.card-product-price[data-vsklo-compare-price]');
    if (!block) return direct || 0;
    var fallback = Number(block.getAttribute('data-vsklo-compare-price') || 0);
    if (fallback && fallback > current) return fallback;
    return direct || 0;
  };
})();

"use strict";

/* VSKLO cart runtime is loaded eagerly by the header for reliable cart-icon behavior.
   This helper is an idempotent readiness/recovery path for product forms and
   dynamically rendered content; ES module caching prevents duplicate execution. */
let vskloCartComponentsPromise = null;
window.vskloEnsureCartComponents = window.vskloEnsureCartComponents || function () {
  const current = document.querySelector("cart-notification#minicart_wrapper") || document.querySelector("cart-notification");
  if (customElements.get("cart-notification") && (!current || typeof current.open === "function")) {
    return Promise.resolve(current || customElements.get("cart-notification"));
  }
  if (vskloCartComponentsPromise) return vskloCartComponentsPromise;
  const cartComponentsSrc = window.VSKLOCartComponentsSrc || "./cart-components.js";
  vskloCartComponentsPromise = import(cartComponentsSrc).catch(function (error) {
    vskloCartComponentsPromise = null;
    throw error;
  });
  return vskloCartComponentsPromise;
};

/* Cart icon trigger ownership lives in cart-components-desktop.js.
   theme.js only exposes the shared lazy loader/open helper for product forms and other callers. */

/* Mobile storefront flow: use the cart page at the shared mobile breakpoint. */
function vskloIsMobileMinicartDisabled() {
  if (typeof window.VSKLOIsCartMobile === 'function') return window.VSKLOIsCartMobile();
  const nav = window.navigator || {};
  return Boolean(
    /Android|iPhone|iPod|iPad|IEMobile|Opera Mini|Mobile/i.test(String(nav.userAgent || '')) ||
    (nav.platform === 'MacIntel' && Number(nav.maxTouchPoints || 0) > 1)
  );
}
function vskloCartUrlForMobileMinicartDisabled() {
  return (window.routes && window.routes.cart_url) || ((window.Shopify && window.Shopify.routes && String(window.Shopify.routes.root || '/').replace(/\/$/, '') + '/cart') || '/cart');
}
function vskloOpenMinicartOrGoToCart(cart) {
  const action = window.themeGlobalVariables?.settings?.action_after_add_cart || 'open_drawer';
  if (vskloIsMobileMinicartDisabled() || action === 'go_to_cart_page') {
    window.location.href = vskloCartUrlForMobileMinicartDisabled();
    return Promise.resolve(false);
  }

  function currentCart() {
    return cart || document.querySelector('cart-notification#minicart_wrapper') || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function openCurrentCart() {
    var target = currentCart();
    if (!target || typeof target.open !== 'function') return Promise.resolve(false);
    target.classList.remove('is-empty');
    return Promise.resolve(target.open()).then(function () {
      return Boolean(
        (typeof target.isOpen === 'function' && target.isOpen()) ||
        target.classList.contains('open') ||
        document.documentElement.classList.contains('open-minicart') ||
        document.querySelector('#minicart_wrapper .minicart__wrapper.open')
      );
    });
  }

  var renderReady =
    window.VSKLOMiniCartRuntime && typeof window.VSKLOMiniCartRuntime.whenReady === 'function'
      ? window.VSKLOMiniCartRuntime.whenReady()
      : Promise.resolve(true);

  return Promise.resolve(renderReady).then(function () {
    return typeof window.VSKLOOpenMiniCart === 'function'
      ? Promise.resolve(window.VSKLOOpenMiniCart())
      : Promise.resolve(false);
  }).then(function (opened) {
    if (opened) return true;
    if (typeof window.vskloEnsureCartComponents !== 'function') return openCurrentCart();
    return window.vskloEnsureCartComponents().then(openCurrentCart);
  }).catch(function (error) {
    console.error('[VSKLO] desktop minicart open failed', error);
    return false;
  });
}
window.VSKLOOpenMinicartOrGoToCart = window.VSKLOOpenMinicartOrGoToCart || vskloOpenMinicartOrGoToCart;

window.VSKLOEnsureSwiperReady = window.VSKLOEnsureSwiperReady || function () {
  if (window.Swiper) return Promise.resolve(window.Swiper);
  if (window.vskloEnsureSwiper) return window.vskloEnsureSwiper();
  return new Promise(function (resolve, reject) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (window.Swiper) {
        window.clearInterval(timer);
        resolve(window.Swiper);
      } else if (attempts >= 80) {
        window.clearInterval(timer);
        reject(new Error("Swiper runtime did not become available"));
      }
    }, 50);
  });
};

const vskloComponentLoaders = {
  productForm: null,
  loadmore: null,
  gridSliders: null,
  productMedia: null,
  termsCookie: null,
  optional: null,
  variants: null,
  quickview: null,
  compare: null,
  countdown: null,
  imageComparison: null,
  reviewProduct: null,
  countUp: null,
  bundle: null,
  loginPopup: null,
  passwordToggle: null,
  account: null
};

function vskloNodeCanHydrate(node) {
  if (!node || !node.closest) return true;
  const minicart = node.closest("#minicart_wrapper");
  if (!minicart) return true;
  const drawer = minicart.querySelector(".minicart__wrapper");
  return Boolean(
    minicart.classList.contains("open") ||
    drawer?.classList.contains("open") ||
    document.documentElement.classList.contains("open-minicart")
  );
}

function vskloRootHas(root, selector) {
  if (!root) return false;
  if (root.matches && root.matches(selector) && vskloNodeCanHydrate(root)) return true;
  if (!root.querySelectorAll) return false;
  return Array.from(root.querySelectorAll(selector)).some(vskloNodeCanHydrate);
}

function vskloImportOnce(key, path) {
  if (!vskloComponentLoaders[key]) {
    vskloComponentLoaders[key] = import(path).catch(function (error) {
      vskloComponentLoaders[key] = null;
      throw error;
    });
  }
  return vskloComponentLoaders[key];
}

window.vskloEnsureProductForm = window.vskloEnsureProductForm || function () {
  return vskloImportOnce("productForm", "./theme-product-form.js");
};
window.vskloEnsureLoadmore = window.vskloEnsureLoadmore || function () {
  return vskloImportOnce("loadmore", "./theme-loadmore.js");
};
window.vskloEnsureGridSliders = window.vskloEnsureGridSliders || function () {
  return window.VSKLOEnsureSwiperReady().then(function () {
    return vskloImportOnce("gridSliders", "./theme-grid-sliders.js");
  });
};
window.vskloEnsureProductMedia = window.vskloEnsureProductMedia || function (needsSwiper) {
  var ready = needsSwiper ? window.VSKLOEnsureSwiperReady() : Promise.resolve();
  return ready.then(function () {
    return vskloImportOnce("productMedia", "./theme-product-media.js");
  });
};
window.vskloEnsureTermsCookie = window.vskloEnsureTermsCookie || function () {
  return vskloImportOnce("termsCookie", "./theme-terms-cookie.js");
};
window.vskloEnsureOptionalComponents = window.vskloEnsureOptionalComponents || function () {
  return vskloImportOnce("optional", "./theme-optional-components.js");
};

window.VSKLOHydrateThemeComponents = window.VSKLOHydrateThemeComponents || function (root) {
  var scope = root && (root.querySelector || root.matches) ? root : document;
  var jobs = [];

  if (vskloRootHas(scope, "product-form")) {
    jobs.push(window.vskloEnsureProductForm());
  }
  if (vskloRootHas(scope, "loadmore-button, loadmore-function")) {
    jobs.push(window.vskloEnsureLoadmore());
  }
  if (vskloRootHas(scope, "multi-content, carousel-mobile, grid-custom")) {
    jobs.push(window.vskloEnsureGridSliders());
  }
  var hasThumbs = vskloRootHas(scope, "slide-with-thumbs");
  if (hasThumbs || vskloRootHas(scope, "media-gallery")) {
    jobs.push(window.vskloEnsureProductMedia(hasThumbs));
  }
  if (vskloRootHas(scope, "cookie-bar, terms-conditions")) {
    jobs.push(window.vskloEnsureTermsCookie());
  }
  if (vskloRootHas(scope, "before-you-leave, video-section, idea-product, progress-stock-bar, product-addons, popup-link")) {
    jobs.push(window.vskloEnsureOptionalComponents());
  }
  if (vskloRootHas(scope, ".img-comp-overlay")) {
    jobs.push(window.vskloEnsureImageComparison());
  }
  if (vskloRootHas(scope, '[data-module~="countup"]')) {
    jobs.push(window.vskloEnsureCountUp());
  }
  if (vskloRootHas(scope, "review-product")) {
    jobs.push(window.vskloEnsureReviewProduct());
  }
  if (vskloRootHas(scope, ".action-login-popup")) {
    jobs.push(vskloMaybeLoadLoginPopup(scope));
  }
  if (vskloRootHas(scope, "variant-radios, variant-radios-detail, variant-radios-single, variant-group-detail, variant-radios-sticky, variant-group-sticky, variant-radios-quick-edit, product-form-quick-edit, swatch-dropdown-select-value")) {
    jobs.push(window.vskloEnsureThemeVariants());
  }
  if (vskloRootHas(scope, "variant-radios-bundle, product-form-bundle, quantity-input-bundle, button-submit-bundle")) {
    jobs.push(window.vskloEnsureThemeBundle());
  }
  if (vskloRootHas(scope, "show-pass-word")) {
    jobs.push(vskloMaybeLoadPasswordToggle(scope));
  }
  if (vskloRootHas(scope, "button-quickview, select-option")) {
    jobs.push(window.vskloEnsureThemeQuickView());
  }
  if (vskloRootHas(scope, "button-compare")) {
    jobs.push(window.vskloEnsureThemeCompare());
  }
  if (vskloRootHas(scope, "countdown-timer")) {
    jobs.push(window.vskloEnsureCountdownTimer());
  }

  return Promise.all(jobs).catch(function (error) {
    console.error("[VSKLO] Component hydration failed:", error);
    return [];
  });
};

/* Global hydration lifecycle is owned by vsklo-runtime-core.js. */

/* VSKLO perf: image-comparison runtime is lazy-loaded by the canonical hydration lifecycle. */
window.vskloEnsureImageComparison = window.vskloEnsureImageComparison || function () {
  return vskloImportOnce("imageComparison", "./theme-image-comparison.js");
};

function eventFlashingBrowseTab() {
  var enable = window.flashingBrowseTab?.enable,
    myTimer,
    message,
    titleTag = document.getElementsByTagName("title")[0],
    first_notification = window.flashingBrowseTab?.firstNotification,
    secondary_notification = window.flashingBrowseTab?.secondaryNotification;
  if (enable && titleTag) {
    var originalTitle = titleTag.innerText;
    var isActive = true;
    document.addEventListener("visibilitychange", () => {
      document.visibilityState === "visible"
        ? (function () {
            if (isActive) return;
            clearInterval(myTimer), (titleTag.innerText = originalTitle);
          })()
        : (function () {
            var i = 1;
            if (
              ((isActive = false),
              !first_notification || !secondary_notification)
            )
              return;
            myTimer = setInterval(function () {
              if (i == 1) {
                message = first_notification;
                i = 2;
              } else {
                message = secondary_notification;
                i = 1;
              }
              titleTag.innerText = message;
            }, 2000);
          })();
    });
  }
}
eventFlashingBrowseTab();

function initializeLazyLoad(root = document) {
  const scope = root && (root.querySelectorAll || root.matches) ? root : document;
  const videoPlaceholders = [];
  if (scope.matches && scope.matches(".lazy-video-link")) {
    videoPlaceholders.push(scope);
  }
  if (scope.querySelectorAll) {
    videoPlaceholders.push(...scope.querySelectorAll(".lazy-video-link"));
  }
  const pending = videoPlaceholders.filter((element) => element.dataset.vskloLazyVideoReady !== "true");
  if (!pending.length) return;

  const loadYouTubeVideo = (element) => {
    const videoId = element.getAttribute("data-video-id");
    if (!videoId) return;
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.youtube.com/embed/${videoId}?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=${videoId}`;
    iframe.allowFullscreen = true;
    iframe.frameBorder = "0";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    element.innerHTML = "";
    element.appendChild(iframe);
  };
  const loadVimeoVideo = (element) => {
    const videoId = element.getAttribute("data-video-id");
    if (!videoId) return;
    const iframe = document.createElement("iframe");
    iframe.src = `https://player.vimeo.com/video/${videoId}?controls=0&background=1&autoplay=1&muted=1&loop=1`;
    iframe.allowFullscreen = true;
    iframe.allow = "autoplay; fullscreen; picture-in-picture";
    iframe.frameBorder = "0";
    element.innerHTML = "";
    element.appendChild(iframe);
  };
  const loadVideo = (element) => {
    const videoType = element.getAttribute("data-video-type");
    if (videoType === "youtube") {
      loadYouTubeVideo(element);
    } else if (videoType === "vimeo") {
      loadVimeoVideo(element);
    }
  };

  if (!("IntersectionObserver" in window)) {
    pending.forEach((element) => {
      element.dataset.vskloLazyVideoReady = "true";
      loadVideo(element);
    });
    return;
  }

  const observer = new IntersectionObserver((entries, currentObserver) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      loadVideo(entry.target);
      currentObserver.unobserve(entry.target);
    });
  });
  pending.forEach((videoPlaceholder) => {
    videoPlaceholder.dataset.vskloLazyVideoReady = "true";
    observer.observe(videoPlaceholder);
  });
}
initializeLazyLoad();
if (window.VSKLOHydration?.register) {
  window.VSKLOHydration.register("lazy-video", initializeLazyLoad);
}

const slideAnime = (() => {
  let isAnimating = false;

  return (setOptions) => {
    const defaultOptions = {
      target: false,
      animeType: "slideToggle",
      duration: 250,
      easing: "ease",
      isDisplayStyle: "block",
      parent: false,
      addFunction: () => {},
    };
    const options = Object.assign({}, defaultOptions, setOptions);
    const target = options.target;
    const ownAnimate = options.ownAnimate;
    if (ownAnimate) {
      isAnimating = false;
    }
    const parent = options.parent;
    if (!target) {
      return;
    }

    if (isAnimating) {
      return;
    }
    isAnimating = true;
    parent.classList?.toggle("opened");

    let animeType = options.animeType;
    const styles = getComputedStyle(target);
    if (animeType === "slideToggle") {
      animeType = styles.display === "none" ? "slideDown" : "slideUp";
    }
    if (
      (animeType === "slideUp" && styles.display === "none") ||
      (animeType === "slideDown" && styles.display !== "none") ||
      (animeType !== "slideUp" && animeType !== "slideDown")
    ) {
      isAnimating = false;
      return false;
    }
    target.style.overflow = "hidden";
    const duration = options.duration;
    const easing = options.easing;
    const isDisplayStyle = options.isDisplayStyle;

    if (animeType === "slideDown") {
      target.style.display = isDisplayStyle;
    }
    const heightVal = {
      height: target.getBoundingClientRect().height + "px",
      marginTop: styles.marginTop,
      marginBottom: styles.marginBottom,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
    };

    Object.keys(heightVal).forEach((key) => {
      if (parseFloat(heightVal[key]) === 0) {
        delete heightVal[key];
      }
    });
    if (Object.keys(heightVal).length === 0) {
      isAnimating = false;
      return false;
    }
    let slideAnime;
    if (animeType === "slideDown") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    } else if (animeType === "slideUp") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = heightVal[key];
        heightVal[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    }
    slideAnime.finished.then(() => {
      options.addFunction();
      target.style.overflow = "";
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = "";
      });
      if (animeType === "slideUp") {
        target.style.display = "none";
      }
      isAnimating = false;
    });
  };
})();


function HoverIntent(exitTime, elements, userConfig) {
  const defaultOptions = {
    exitDelay: exitTime,
    interval: 100,
    sensitivity: 6,
  };
  let config = {};
  let currX, currY, prevX, prevY;
  let allElems, pollTimer, exitTimer;
  const extend = function (defaults, userArgs) {
    for (let i in userArgs) {
      defaults[i] = userArgs[i];
    }
    return defaults;
  };
  const mouseTrack = function (ev) {
    currX = ev.pageX;
    currY = ev.pageY;
  };
  const mouseCompare = function (targetElem) {
    const distX = prevX - currX,
      distY = prevY - currY;
    const distance = Math.sqrt(distX * distX + distY * distY);
    if (distance < config.sensitivity) {
      clearTimeout(exitTimer);
      for (let elem of allElems) {
        if (elem.isActive) {
          config.onExit(elem);
          elem.isActive = false;
        }
      }
      config.onEnter(targetElem);
      targetElem.isActive = true;
    } else {
      prevX = currX;
      prevY = currY;
      pollTimer = setTimeout(function () {
        mouseCompare(targetElem);
      }, config.interval);
    }
  };
  const init = function (exitTime, elements, userConfig) {
    if (!userConfig || !userConfig.onEnter || !userConfig.onExit) {
      throw "onEnter and onExit callbacks must be provided";
    }
    config = extend(defaultOptions, userConfig);
    allElems = elements;
    for (let elem of allElems) {
      if (!elem) return;
      elem.isActive = false;
      elem.addEventListener("mousemove", mouseTrack);
      elem.addEventListener("mouseenter", function (ev) {
        prevX = ev.pageX;
        prevY = ev.pageY;
        if (elem.isActive) {
          clearTimeout(exitTimer);
          return;
        }
        pollTimer = setTimeout(function () {
          mouseCompare(elem);
        }, config.interval);
      });
      elem.addEventListener("mouseleave", function (ev) {
        clearTimeout(pollTimer);
        if (!elem.isActive) return;
        exitTimer = setTimeout(function () {
          config.onExit(elem);
          elem.isActive = false;
        }, config.exitDelay);
      });
    }
  };
  init(exitTime, elements, userConfig);
}

let BlsMainMenuShopify = (function () {
  return {
    init: function () {
      this.initMenu();
      this.initMainMenu();
      this.initMobileMenu();
      this.initVerticalMenu();
    },

    initMenu: function () {
      const header = document.querySelector("header");
      if (!header) return;

      // Cache DOM elements
      const elements = {
        categoriesListMenuMobile: document.querySelector(
          ".categories-list-menu-mobile"
        ),
        categoriesListMenu: document.querySelector(
          '[data-menu="categories-list"]'
        ),
        categoriesListMenuVertical: document.querySelector(
          '[data-menu="verticalmenu-list"]'
        ),
        categoriesListMenuVerticalMobile: document.querySelector(
          ".verticalmenu-mobile"
        ),
        horizontalList: document.querySelector("nav.mobile .horizontal-list"),
      };

      // Calculate section padding bottom value
      const sectionPbValue = this.calculateSectionPadding(header);

      // Initialize fade-in-down animation if present
      this.initFadeInDownAnimation(header, sectionPbValue);

      // Handle menu tab switching
      this.setupMenuTabSwitching(elements);

      // Initialize menu tab state based on window width
      this.updateMenuTabState(elements);
      this.updateMenuVerticalMobile(elements);

      // Add resize event listener for responsive behavior
      let menuResizeFrame = 0;
      window.addEventListener("resize", () => {
        if (menuResizeFrame) return;
        menuResizeFrame = window.requestAnimationFrame(() => {
          menuResizeFrame = 0;
          this.updateMenuTabState(elements);
          this.updateMenuVerticalMobile(elements);
        });
      }, { passive: true });
    },

    calculateSectionPadding: function (header) {
      let sectionPbValue = parseInt(
        getComputedStyle(header).getPropertyValue("--section-pb").trim()
      );
      if (header.querySelector(".header__layout-2")) {
        sectionPbValue = 0;
      }
      return sectionPbValue;
    },

    initFadeInDownAnimation: function (header, sectionPbValue) {
      const fadeInDown = document.querySelector(".fade-in-down");
      if (!fadeInDown) {
        // Simple hover intent for non-fade-in menus
        this.setupSimpleHoverIntent(180, ".menu-parent__horizontal");
        return;
      }

      HoverIntent(180, document.querySelectorAll(".menu-parent__horizontal"), {
        onEnter: (targetItem) =>
          this.handleMenuEnter(targetItem, header, sectionPbValue),
        onExit: (targetItem) => this.handleMenuExit(targetItem, header),
      });
    },

    setupSimpleHoverIntent: function (time, selector) {
      HoverIntent(time, document.querySelectorAll(selector), {
        onEnter: function (targetItem) {
          targetItem.classList.add("visible");
        },
        onExit: function (targetItem) {
          targetItem.classList.remove("visible");
        },
      });
    },

    handleMenuEnter: function (targetItem, header, sectionPbValue) {
      const submenu = targetItem.querySelector(".submenu-horizontal");
      if (!submenu) return;

      const width = window.innerWidth;
      if (width <= 1024) return;

      const sticky = header?.getAttribute("data-sticky");
      if (sticky == "on-scroll-up") {
        header.classList.add("open-submenu");
      }

      if (document.documentElement.classList.contains("open-search")) {
        this.handleMenuEnterWithSearchOpen(targetItem, submenu, sectionPbValue);
      } else {
        this.handleStandardMenuEnter(targetItem, submenu, header);
      }
    },

    handleStandardMenuEnter: function (targetItem, submenu, header) {
      const outerRect = header.getBoundingClientRect();
      const innerRect = targetItem.getBoundingClientRect();
      const heightScrollDown = outerRect.bottom - innerRect.bottom;

      Motion.animate(
        submenu,
        {
          y: ["-105%", heightScrollDown],
          visibility: ["hidden", "visible"],
        },
        {
          ease: [0.7, 0, 0.2, 1],
          duration: 0.35,
        }
      );

      targetItem.classList.add("visible");
      if (!header.classList.contains("border-bottom")) {
        header.classList.add("active");
      }
    },

    handleMenuEnterWithSearchOpen: function (
      targetItem,
      submenu,
      sectionPbValue
    ) {
      document.dispatchEvent(new CustomEvent("vsklo:desktop-search-close"));
      Motion.animate(
        submenu,
        {
          y: ["-105%", sectionPbValue],
          visibility: ["hidden", "visible"],
        },
        {
          ease: [0.7, 0, 0.2, 1],
          duration: 0.35,
        }
      );
      targetItem.classList.add("visible");
    },

    handleMenuExit: function (targetItem, header) {
      const submenu = targetItem.querySelector(".submenu-horizontal");
      if (!submenu) return;

      const width = window.innerWidth;
      if (width <= 1024) return;

      const sticky = header?.getAttribute("data-sticky");
      const outerRect = header.getBoundingClientRect();
      const innerRect = targetItem.getBoundingClientRect();
      const heightScrollDown = outerRect.bottom - innerRect.bottom;

      if (sticky == "on-scroll-up") {
        header.classList.remove("open-submenu");
      }

      Motion.animate(
        submenu,
        {
          y: [heightScrollDown, "-105%"],
          visibility: ["visible", "hidden"],
        },
        {
          ease: [0.7, 0, 0.2, 1],
          duration: 0.4,
        }
      );

      targetItem.classList.remove("visible");
      if (header.classList.contains("active")) {
        header.classList.remove("active");
      }
    },

    setupMenuTabSwitching: function (elements) {
      document.querySelectorAll(".menu-mobile-title a").forEach((tabToggle) => {
        tabToggle.addEventListener("click", (e) => {
          e.preventDefault();
          const target = e.currentTarget;
          const data = target.dataset.menu;

          // Reset active state on all tabs
          document
            .querySelectorAll(".menu-mobile-title a")
            .forEach((item) => item.classList.remove("active"));

          // Set current tab as active
          target.classList.add("active");

          // Show appropriate menu based on selected tab
          this.showMenuForTab(data, elements);
        });
      });
    },

    showMenuForTab: function (tabId, elements) {
      const { horizontalList, categoriesListMenuMobile } = elements;
      const categoriesListMenuVerticalMobile = document.querySelector(
        ".verticalmenu-mobile"
      );

      if (!horizontalList) return;

      // Hide horizontal list if we're showing a specific menu
      horizontalList.style.display =
        tabId !== "horizontal-list" ? "none" : "block";

      // Show appropriate menu based on tab
      if (tabId === "categories-list") {
        if (categoriesListMenuMobile)
          categoriesListMenuMobile.style.display = "block";
        if (categoriesListMenuVerticalMobile)
          categoriesListMenuVerticalMobile.style.display = "none";
      } else if (tabId === "verticalmenu-list") {
        if (categoriesListMenuMobile)
          categoriesListMenuMobile.style.display = "none";
        if (categoriesListMenuVerticalMobile)
          categoriesListMenuVerticalMobile.style.display = "block";
      } else {
        if (categoriesListMenuMobile)
          categoriesListMenuMobile.style.display = "none";
        if (categoriesListMenuVerticalMobile)
          categoriesListMenuVerticalMobile.style.display = "none";
      }
    },

    updateMenuVerticalMobile: function (elements) {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const headerVertical = document.querySelector(".header-vertical");
        const headerVerticalMobile = document.querySelector(
          ".verticalmenu-mobile"
        );
        const titleVertical = headerVerticalMobile?.dataset.title;
        const menuMobileTitle = document.querySelector(".menu-mobile-title");
        if (!headerVertical) return;
        if (!menuMobileTitle.querySelector('[data-menu="verticalmenu-list"]')) {
          const contentAppendTitleVertical = `
            <a
              class="no-underline heading-style py-10"
              data-menu="verticalmenu-list"
              role="link"
              aria-disabled="true"
            >
              ${titleVertical}
            </a>
          `;
          menuMobileTitle.insertAdjacentHTML(
            "beforeend",
            contentAppendTitleVertical
          );
          const newTabButton = menuMobileTitle.querySelector(
            '[data-menu="verticalmenu-list"]'
          );
          if (newTabButton) {
            newTabButton.addEventListener("click", (e) => {
              e.preventDefault();
              document
                .querySelectorAll(".menu-mobile-title a")
                .forEach((item) => item.classList.remove("active"));
              newTabButton.classList.add("active");
              this.showMenuForTab("verticalmenu-list", elements);
            });
          }
        }
        const wrapperVerticalmenu = document.querySelector(
          ".verticalmenu-mobile"
        );
        const navigationMenuContent = document.querySelector(
          ".navigation__menu-content-mobile"
        );
        if (!wrapperVerticalmenu || !navigationMenuContent) {
          return;
        }
        if (!navigationMenuContent.querySelector(".verticalmenu-mobile")) {
          const cloneWrapper = wrapperVerticalmenu.cloneNode(true);
          navigationMenuContent.appendChild(cloneWrapper);
        }
      }
    },

    updateMenuTabState: function (elements) {
      const windowWidth = window.innerWidth;
      const {
        horizontalList,
        categoriesListMenu,
        categoriesListMenuVertical,
        categoriesListMenuMobile,
        categoriesListMenuVerticalMobile,
      } = elements;

      if (!horizontalList || !categoriesListMenu) return;

      if (windowWidth <= 1024) {
        // Mobile view
        if (
          categoriesListMenu?.classList.contains("active") ||
          categoriesListMenuVertical?.classList.contains("active")
        ) {
          horizontalList.style.display = "none";
        }

        if (
          categoriesListMenuVerticalMobile &&
          categoriesListMenuVertical?.classList.contains("active")
        ) {
          categoriesListMenuVerticalMobile.style.display = "block";
        }
      } else {
        // Desktop view
        if (
          categoriesListMenuMobile &&
          categoriesListMenu?.classList.contains("active")
        ) {
          categoriesListMenuMobile.style.display = "none";
        }

        if (
          categoriesListMenuVerticalMobile &&
          categoriesListMenuVertical?.classList.contains("active")
        ) {
          categoriesListMenuVerticalMobile.style.display = "none";
        }

        if (
          categoriesListMenu?.classList.contains("active") ||
          categoriesListMenuVertical?.classList.contains("active")
        ) {
          horizontalList.style.display = "inline-flex";
        }
      }
    },

    initMainMenu: function () {
      const header = document.querySelector("header");
      if (!header) return;

      const sticky = header.getAttribute("data-sticky");
      const stickyMobile = header.getAttribute("data-sticky-mobile");
      const needsStickyGeometry =
        sticky !== "none" &&
        !(stickyMobile === "false" && window.innerWidth < 1025);
      const headerGeometry = this.measureHeaderGeometry(
        header,
        needsStickyGeometry
      );

      this.setupNavToggle();
      this.setupMenuMouseEvents();
      this.setupHeaderAttributes(headerGeometry.headerHeight);
      // Scroll reveal is owned by the single vsklo-header-state.js controller.
      this.initSubMenu();
    },

    measureHeaderGeometry: function (header, includeStickyThreshold) {
      const headerHeight = header?.clientHeight || 0;

      if (!includeStickyThreshold) {
        return {
          headerHeight,
          stickyThreshold: 0,
        };
      }

      const headerSpaceH =
        document.getElementById("header-sticky")?.offsetHeight || 0;
      const announcementBarHeight =
        document.querySelector(".section-announcement-bar")?.clientHeight || 0;
      const topBarHeight =
        document.querySelector(".section-top-bar")?.clientHeight || 0;

      return {
        headerHeight,
        stickyThreshold: announcementBarHeight + topBarHeight + headerSpaceH,
      };
    },

    setupNavToggle: function () {
      const closeDesktopNav = () => {
        const html = document.documentElement;
        const hasDesktopNavOwner =
          html.classList.contains("nav-open") ||
          window.VSKLOOverlayState?.has?.("desktop-nav");
        if (!hasDesktopNavOwner) return false;

        html.classList.remove("nav-open", "nav-verticalmenu");
        document.querySelectorAll(".nav-toggle.open").forEach((toggle) => {
          toggle.classList.remove("open");
          toggle.setAttribute("aria-expanded", "false");
        });
        window.VSKLOOverlayState?.release?.("desktop-nav");
        if (window.VSKLOCleanupSharedDrawerShell) window.VSKLOCleanupSharedDrawerShell();
        else {
          html.classList.remove("open-drawer");
          root.style.removeProperty("padding-right");
        }
        return true;
      };

      window.VSKLOCloseDesktopNav = closeDesktopNav;

      document.querySelectorAll(".nav-toggle").forEach((navToggle) => {
        if (navToggle.dataset.vskloNavToggleBound === "true") return;
        navToggle.dataset.vskloNavToggleBound = "true";
        navToggle.setAttribute("aria-expanded", navToggle.classList.contains("open") ? "true" : "false");

        navToggle.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const main_menu = document.querySelector(".navigation.horizontal");

          if (document.documentElement.classList.contains("nav-open")) {
            closeDesktopNav();
            return;
          }

          if (typeof window.VSKLOCloseDesktopSearch === "function") {
            window.VSKLOCloseDesktopSearch(false, true);
          }

          if (document.documentElement.classList.contains("open-minicart")) {
            const cart =
              document.querySelector("cart-notification#minicart_wrapper") ||
              document.querySelector("cart-drawer");
            if (cart && typeof cart.close === "function") cart.close();
          }

          root.style.setProperty(
            "padding-right",
            getScrollBarWidth.init() + "px"
          );
          document.documentElement.classList.add("nav-open", "open-drawer");
          window.VSKLOOverlayState?.acquire?.("desktop-nav");
          target.classList.add("open");
          target.setAttribute("aria-expanded", "true");
          if (!main_menu) {
            document.documentElement.classList.add("nav-verticalmenu");
          }
        });
      });

      if (!window.__VSKLO_DESKTOP_NAV_VIEWPORT_CLEANUP__) {
        window.__VSKLO_DESKTOP_NAV_VIEWPORT_CLEANUP__ = true;
        const mobileQuery =
          (window.VSKLOBreakpoints && window.VSKLOBreakpoints.mobileQuery) ||
          "(max-width: 1024px)";
        const mobileMedia = window.matchMedia ? window.matchMedia(mobileQuery) : null;

        const closeDesktopNavOnMobile = () => {
          const isMobile = mobileMedia ? mobileMedia.matches : window.innerWidth <= 1024;
          if (!isMobile) return;
          closeDesktopNav();
        };

        if (mobileMedia && mobileMedia.addEventListener) {
          mobileMedia.addEventListener("change", closeDesktopNavOnMobile);
        } else if (mobileMedia && mobileMedia.addListener) {
          mobileMedia.addListener(closeDesktopNavOnMobile);
        } else {
          window.addEventListener("resize", closeDesktopNavOnMobile, { passive: true });
        }
        window.addEventListener("pageshow", closeDesktopNavOnMobile);
        closeDesktopNavOnMobile();
      }
    },

    setupMenuMouseEvents: function () {
      let width = screen.width;
      if (width <= 1024) return;

      document
        .querySelectorAll("li.menu-parent .submenu")
        .forEach((menuItem) => {
          menuItem.addEventListener("mouseenter", (e) => {
            const target = e.currentTarget;
            target.closest(".menu-parent").classList.add("active-submenu");
          });

          menuItem.addEventListener("mouseleave", (e) => {
            const target = e.currentTarget;
            target.closest(".menu-parent").classList.remove("active-submenu");
          });
        });
    },

    setupHeaderAttributes: function (headerHeight) {
      const measuredHeight = Number.isFinite(headerHeight)
        ? headerHeight
        : document.querySelector("header")?.clientHeight || 0;
      const body = document.querySelector("body");
      if (body) body.style.setProperty('--height-header', `${measuredHeight}px`);
    },

    initStickyHeader: function (header, measuredHeaderThreshold) {
      const sticky = header?.getAttribute("data-sticky");
      const sticky_mobile = header?.getAttribute("data-sticky-mobile");

      if (sticky === "none") return;
      if (sticky_mobile === "false" && window.innerWidth < 1025) return;

      // Setup header sticky behavior. Use the measurements collected before
      // any header-related style writes to avoid a read -> write -> read layout cycle.
      const headerh = Number.isFinite(measuredHeaderThreshold)
        ? measuredHeaderThreshold
        : (
            (document.querySelector(".section-announcement-bar")?.clientHeight || 0) +
            (document.querySelector(".section-top-bar")?.clientHeight || 0) +
            (document.getElementById("header-sticky")?.offsetHeight || 0)
          );
      this.lastScrollPosition = 0; // Initialize lastScrollPosition property
      const sec_header = header.closest(".section-header");

      if (!sec_header) return;

      if (sticky === "on-scroll-up") {
        sec_header.classList.add("scroll-up");
      }

      let stickyScrollFrame = 0;
      window.addEventListener("scroll", () => {
        if (stickyScrollFrame) return;
        stickyScrollFrame = window.requestAnimationFrame(() => {
          stickyScrollFrame = 0;
          if (header.classList.contains("open-submenu")) return;
          const mobileStickyDisabled =
            sticky_mobile === "false" &&
            (typeof window.VSKLOIsMobile === "function"
              ? window.VSKLOIsMobile()
              : window.innerWidth <= 1024);
          if (mobileStickyDisabled) return;
          this.updateStickyHeader(sec_header, sticky, headerh);
        });
      }, { passive: true });
    },

    updateStickyHeader: function (sec_header, sticky, headerh) {
      let wpy = window.scrollY;

      if (sticky === "always") {
        // Always sticky behavior
        if (wpy > headerh) {
          sec_header.classList.add("shopify-section-header-sticky", "animate");
        } else {
          sec_header.classList.remove(
            "shopify-section-header-sticky",
            "animate"
          );
        }
      } else {
        // Scroll-up sticky behavior
        if (wpy > 0) {
          if (wpy > headerh) {
            sec_header.classList.add("scr-pass-header");

            if (wpy > this.lastScrollPosition) {
              sec_header.classList.add("shopify-section-header-hidden");
            } else {
              sec_header.classList.remove("shopify-section-header-hidden");
              sec_header.classList.add("animate");
            }
            sec_header.classList.add(
              "header-sticky",
              "shopify-section-header-sticky"
            );
            this.lastScrollPosition = wpy;
          } else {
            sec_header.classList.remove("header-sticky", "scr-pass-header");
            this.lastScrollPosition = 0;
          }
        } else {
          sec_header.classList.remove(
            "shopify-section-header-hidden",
            "header-sticky",
            "animate",
            "shopify-section-header-sticky"
          );
        }
      }
    },

    initSubMenu: function () {
      const main_menu = document.querySelector(".navigation.horizontal");
      if (!main_menu || window.innerWidth <= 1024) return;

      this.addCssSubMenu();

      let submenuResizeFrame = 0;
      window.addEventListener("resize", () => {
        if (window.innerWidth <= 1024 || submenuResizeFrame) return;
        submenuResizeFrame = window.requestAnimationFrame(() => {
          submenuResizeFrame = 0;
          if (window.innerWidth > 1024) this.addCssSubMenu();
        });
      }, { passive: true });
    },

    addCssSubMenu: function () {
      const bodyWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
      const header = document.querySelector("header");
      const submenu_center = document.querySelector(".submenu-center");
      const width_sub_center = 800;

      if (!header || bodyWidth <= 1024) return;

      const padding = 30;
      const updates = [];

      // Measure every submenu first. Applying style.left only after all reads
      // prevents one submenu write from forcing layout before the next read.
      document
        .querySelectorAll(".horizontal-list .mega-menu-fix-width")
        .forEach((submenu) => {
          let nextLeft = null;

          if (submenu_center) {
            const submenu_data = submenu.getBoundingClientRect();
            const width = submenu_data.width;
            const left = submenu_data.left;
            const right = submenu_data.right;

            if (width_sub_center <= width) {
              nextLeft = (left - (right - bodyWidth)) / 2;
            }
          } else {
            const elementWidth = submenu.clientWidth;
            const elementLeft = submenu.offsetLeft;

            if (bodyWidth - (elementWidth + elementLeft) < 0) {
              let left = bodyWidth - (elementWidth + elementLeft);
              left = left + elementLeft - padding;
              if (elementLeft < 0) left = 0;
              nextLeft = left;
            }
          }

          if (nextLeft !== null) updates.push([submenu, nextLeft]);
        });

      updates.forEach(([submenu, left]) => {
        submenu.style.left = left + "px";
      });
    },

    initVerticalMenu: function () {
      const article = document.querySelector(".verticalmenu-html");
      if (!article) return;

      const verticalMenu = document.querySelector(".vertical-menu");
      if (!verticalMenu) return;
      verticalMenu.addEventListener("mouseenter", function () {
        setTimeout(function () {
          verticalMenu.classList.add("open-vertical");
        }, 150);
      });
      verticalMenu.addEventListener("mouseleave", function () {
        verticalMenu.classList.remove("open-vertical");
      });
      this.setupSimpleHoverIntent(1, ".menu-parent__vertical");
    },

    initMobileMenu: function () {
      // Reserved for mobile menu specific initialization
    },
  };
})();
function vskloInitDesktopMainMenuOnce() {
  const desktopQuery =
    (window.VSKLOBreakpoints && window.VSKLOBreakpoints.desktopQuery) ||
    "(min-width: 1025px)";
  const isDesktop = window.matchMedia
    ? window.matchMedia(desktopQuery).matches
    : window.innerWidth >= 1025;
  if (!isDesktop || window.__VSKLO_DESKTOP_MAIN_MENU_READY__) return;
  window.__VSKLO_DESKTOP_MAIN_MENU_READY__ = true;
  BlsMainMenuShopify.init();
}

vskloInitDesktopMainMenuOnce();
const vskloDesktopMainMenuMedia = window.matchMedia
  ? window.matchMedia(
      (window.VSKLOBreakpoints && window.VSKLOBreakpoints.desktopQuery) ||
        "(min-width: 1025px)"
    )
  : null;
if (vskloDesktopMainMenuMedia?.addEventListener) {
  vskloDesktopMainMenuMedia.addEventListener("change", (event) => {
    if (event.matches) vskloInitDesktopMainMenuOnce();
  });
} else if (vskloDesktopMainMenuMedia?.addListener) {
  vskloDesktopMainMenuMedia.addListener((event) => {
    if (event.matches) vskloInitDesktopMainMenuOnce();
  });
} else {
  window.addEventListener("resize", vskloInitDesktopMainMenuOnce, { passive: true });
}
var BlsSearchShopify = (function () {
  const SEARCH_SECTION_ID = "search-predictive-grid";
  const debounceTimers = new WeakMap();
  const requestControllers = new WeakMap();
  const defaultSurfaceMarkup = new WeakMap();
  const resultCache = new Map();

  function getSearchFormFromToggle(toggle) {
    const host = document.querySelector("header-search");
    if (!host) return null;
    return host.querySelector("#search-form");
  }

  function getInput(form) {
    return form ? form.querySelector('input[type="search"]') : null;
  }

  function getSurface(form) {
    const input = getInput(form);
    if (!input) return null;
    const controls = input.getAttribute("aria-controls");
    if (!controls) return null;
    return document.getElementById(controls);
  }

  function getResultsContainer(surface) {
    return surface ? surface.querySelector("[data-predictive-search]") : null;
  }

  function getQuickSearch(surface) {
    if (!surface || !surface.parentElement) return null;
    return surface.parentElement.querySelector("[data-vsklo-quick-search]");
  }

  function setLoading(form, surface, loading) {
    if (form) form.classList.toggle("loading", loading);
    if (surface) surface.classList.toggle("loading", loading);
  }

  function setExpanded(form, expanded) {
    const input = getInput(form);
    if (input) input.setAttribute("aria-expanded", expanded ? "true" : "false");
  }

  function resetSurface(form, surface) {
    const results = getResultsContainer(surface);
    const quickSearch = getQuickSearch(surface);
    if (surface) surface.classList.remove("results", "loading");
    if (results) {
      const initialMarkup = defaultSurfaceMarkup.get(surface);
      if (typeof initialMarkup === "string") results.innerHTML = initialMarkup;
      if (window.vskloHydrateDefaultSearchSuggestions) window.vskloHydrateDefaultSearchSuggestions(surface);
      results.removeAttribute("style");
    }
    if (quickSearch) quickSearch.classList.remove("hidden");
    if (form) form.classList.remove("loading");
    setExpanded(form, false);
  }

  function assignOptionIds(surface) {
    if (!surface || !surface.id) return;
    surface.querySelectorAll('[role="option"]').forEach((option, index) => {
      option.id = surface.id + "-option-" + index;
      option.setAttribute("aria-selected", "false");
    });
  }

  function clearSelection(form, surface) {
    if (!surface) return;
    surface.querySelectorAll('[role="option"][aria-selected="true"]').forEach((option) => {
      option.setAttribute("aria-selected", "false");
    });
    const input = getInput(form);
    if (input) input.setAttribute("aria-activedescendant", "");
  }

  function renderResults(form, surface, markup) {
    const results = getResultsContainer(surface);
    if (!surface || !results) return;
    results.innerHTML = markup;
    document.dispatchEvent(new CustomEvent("vsklo:content-updated", {
      detail: { scope: results, source: "predictive-search" }
    }));
    assignOptionIds(surface);
    surface.classList.add("results");
    const quickSearch = getQuickSearch(surface);
    if (quickSearch) quickSearch.classList.add("hidden");
    setLoading(form, surface, false);
    setExpanded(form, true);
  }

  function fetchResults(form, searchTerm) {
    const surface = getSurface(form);
    if (!surface) return;

    const locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || "";
    const cacheKey = locale + "::" + searchTerm.toLowerCase();
    if (resultCache.has(cacheKey)) {
      renderResults(form, surface, resultCache.get(cacheKey));
      return;
    }

    const previousController = requestControllers.get(form);
    if (previousController) previousController.abort();

    const controller = new AbortController();
    requestControllers.set(form, controller);
    setLoading(form, surface, true);

    const predictiveUrl =
      window.routes && routes.predictive_search_url
        ? routes.predictive_search_url
        : "/search/suggest";

    const url =
      predictiveUrl +
      "?q=" + encodeURIComponent(searchTerm) +
      "&resources[type]=product" +
      "&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku" +
      "&resources[options][prefix]=last" +
      "&resources[options][unavailable_products]=last" +
      "&section_id=" + SEARCH_SECTION_ID;

    fetch(url, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error("Predictive search request failed: " + response.status);
        return response.text();
      })
      .then((text) => {
        const currentInput = getInput(form);
        if (!currentInput || currentInput.value.trim() !== searchTerm) return;
        const parsed = new DOMParser().parseFromString(text, "text/html");
        const section = parsed.querySelector("#shopify-section-" + SEARCH_SECTION_ID);
        if (!section) throw new Error("Predictive search section missing from response");
        const markup = section.innerHTML;
        resultCache.set(cacheKey, markup);
        renderResults(form, surface, markup);
        if (window.BlsLazyloadImg && typeof BlsLazyloadImg.init === "function") {
          BlsLazyloadImg.init();
        }
      })
      .catch((error) => {
        if (error && error.name === "AbortError") return;
        setLoading(form, surface, false);
        resetSurface(form, surface);
        console.error("[VSKLO] Predictive search:", error);
      });
  }

  function handleInput(form) {
    const input = getInput(form);
    const surface = getSurface(form);
    if (!input || !surface) return;

    const searchTerm = input.value.trim();
    clearSelection(form, surface);

    const previousTimer = debounceTimers.get(form);
    if (previousTimer) window.clearTimeout(previousTimer);

    if (!searchTerm) {
      const controller = requestControllers.get(form);
      if (controller) controller.abort();
      resetSurface(form, surface);
      return;
    }

    const timer = window.setTimeout(() => fetchResults(form, searchTerm), 300);
    debounceTimers.set(form, timer);
  }

  function selectOption(form, surface, direction) {
    if (!surface || !surface.classList.contains("results")) return;
    const options = Array.from(surface.querySelectorAll('[role="option"]'));
    if (!options.length) return;

    const current = surface.querySelector('[role="option"][aria-selected="true"]');
    let index = current ? options.indexOf(current) : -1;
    index = direction === "up"
      ? (index <= 0 ? options.length - 1 : index - 1)
      : (index >= options.length - 1 ? 0 : index + 1);

    if (current) current.setAttribute("aria-selected", "false");
    const next = options[index];
    next.setAttribute("aria-selected", "true");

    const input = getInput(form);
    if (input && next.id) input.setAttribute("aria-activedescendant", next.id);
    if (typeof next.scrollIntoView === "function") {
      next.scrollIntoView({ block: "nearest" });
    }
  }

  function activateSelected(surface) {
    if (!surface) return false;
    const selected = surface.querySelector('[role="option"][aria-selected="true"]');
    if (!selected) return false;
    const link = selected.querySelector("a[href]");
    if (!link) return false;
    link.click();
    return true;
  }

  function bindPredictiveForm(form) {
    if (!form || form.dataset.vskloSearchReady === "true") return;
    const input = getInput(form);
    const surface = getSurface(form);
    if (!input || !surface) return;

    const initialResults = getResultsContainer(surface);
    if (initialResults && !defaultSurfaceMarkup.has(surface)) {
      defaultSurfaceMarkup.set(surface, initialResults.innerHTML);
    }

    form.dataset.vskloSearchReady = "true";

    input.addEventListener("input", () => handleInput(form));
    input.addEventListener("focus", () => {
      const term = input.value.trim();
      if (term && !surface.classList.contains("results")) fetchResults(form, term);
    });
    input.addEventListener("keydown", (event) => {
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        event.preventDefault();
        selectOption(form, surface, event.key === "ArrowUp" ? "up" : "down");
        return;
      }
      if (event.key === "Enter" && activateSelected(surface)) {
        event.preventDefault();
        return;
      }
      if (event.key === "Escape") {
        clearSelection(form, surface);
        setExpanded(form, false);
      }
    });

    form.addEventListener("submit", (event) => {
      if (activateSelected(surface)) {
        event.preventDefault();
        return;
      }
      if (!input.value.trim()) event.preventDefault();
    });
  }

  function syncMobileSearchGeometry() {
    if (!vskloIsMobileMinicartDisabled()) return;

    const header =
      document.querySelector(".section-header .header") ||
      document.querySelector(".section-header") ||
      document.querySelector("header");

    const top = header
      ? Math.max(0, Math.round(header.getBoundingClientRect().bottom))
      : 0;

    document.documentElement.style.setProperty(
      "--vsklo-mobile-search-top",
      top + "px"
    );
  }

  function closeMobileSearch(form) {
    if (!form) return;
    form.classList.remove("open");
    form.setAttribute("aria-hidden", "true");
    form.setAttribute("inert", "");
    document.querySelectorAll(".top-search-toggle.open").forEach((toggle) => {
      toggle.classList.remove("open");
      toggle.setAttribute("aria-expanded", "false");
    });
    document.documentElement.classList.remove("open-search");
    document.documentElement.style.removeProperty("--vsklo-mobile-search-top");
    window.VSKLOOverlayState?.release?.("search");
    window.setTimeout(() => {
      if (window.VSKLOCleanupSharedDrawerShell) window.VSKLOCleanupSharedDrawerShell();
      else {
        document.documentElement.classList.remove("open-drawer");
        root.style.removeProperty("padding-right");
      }
    }, 300);
  }

  function closeAllMobileSearch() {
    let closed = false;
    document
      .querySelectorAll("header-search #search-form.open, #search-form.open")
      .forEach((panel) => {
        closed = true;
        closeMobileSearch(panel);
      });
    return closed;
  }

  window.VSKLOCloseMobileSearch = closeAllMobileSearch;

  let mobileSearchViewportCleanupBound = false;

  function bindMobileSearchViewportCleanup() {
    if (mobileSearchViewportCleanupBound) return;
    mobileSearchViewportCleanupBound = true;

    const query = (window.VSKLOBreakpoints && window.VSKLOBreakpoints.mobileQuery) || "(max-width: 1024px)";
    const media = window.matchMedia ? window.matchMedia(query) : null;

    const closeOnDesktop = () => {
      const isMobile = media ? media.matches : vskloIsMobileMinicartDisabled();
      if (isMobile) return;
      document.querySelectorAll("header-search #search-form.open, #search-form.open").forEach((panel) => {
        closeMobileSearch(panel);
      });
    };

    if (media && media.addEventListener) media.addEventListener("change", closeOnDesktop);
    else window.addEventListener("resize", closeOnDesktop, { passive: true });

    let geometryFrame = 0;
    const syncOpenMobileSearch = () => {
      if (!document.querySelector("header-search #search-form.open")) return;
      if (geometryFrame) cancelAnimationFrame(geometryFrame);
      geometryFrame = requestAnimationFrame(() => {
        geometryFrame = 0;
        syncMobileSearchGeometry();
      });
    };
    window.addEventListener("resize", syncOpenMobileSearch, { passive: true });
    window.addEventListener("orientationchange", syncOpenMobileSearch, { passive: true });
  }

  function bindMobileSearch() {
    document.querySelectorAll(".top-search-toggle").forEach((toggle) => {
      if (toggle.dataset.vskloSearchToggleReady === "true") return;
      toggle.dataset.vskloSearchToggleReady = "true";
      toggle.setAttribute("aria-expanded", "false");

      toggle.addEventListener("click", (event) => {
        if (!vskloIsMobileMinicartDisabled()) return;
        event.preventDefault();
        event.stopPropagation();

        const panel = getSearchFormFromToggle(toggle);
        if (!panel) return;

        if (panel.classList.contains("open")) {
          closeMobileSearch(panel);
          return;
        }

        syncMobileSearchGeometry();
        panel.classList.add("open");
        panel.setAttribute("aria-hidden", "false");
        panel.removeAttribute("inert");
        toggle.classList.add("open");
        toggle.setAttribute("aria-expanded", "true");
        document.documentElement.classList.add("open-drawer", "open-search");
        window.VSKLOOverlayState?.acquire?.("search");
        root.style.setProperty("padding-right", getScrollBarWidth.init() + "px");

        if (document.documentElement.classList.contains("vsklo-mobile-drawer-open")) {
          if (typeof window.VSKLOMobileDrawerClose === "function") {
            window.VSKLOMobileDrawerClose();
          } else {
            document.documentElement.classList.remove("vsklo-mobile-drawer-open");
          }
        }

        window.setTimeout(() => {
          const input = panel.querySelector('input[type="search"]');
          if (input) input.focus();
        }, 100);
      });
    });

    document.querySelectorAll("#search-form .btn-search-close").forEach((button) => {
      if (button.dataset.vskloSearchCloseReady === "true") return;
      button.dataset.vskloSearchCloseReady = "true";
      button.addEventListener("click", (event) => {
        if (!vskloIsMobileMinicartDisabled()) return;
        event.preventDefault();
        closeMobileSearch(button.closest("#search-form"));
      });
    });

    const overlay = document.querySelector(".overlay_search");
    if (overlay && overlay.dataset.vskloMobileSearchOverlayReady !== "true") {
      overlay.dataset.vskloMobileSearchOverlayReady = "true";
      overlay.addEventListener("click", () => {
        if (!vskloIsMobileMinicartDisabled()) return;
        const panel = document.querySelector("header-search #search-form.open");
        if (panel) closeMobileSearch(panel);
      });
    }
  }

  window.addEventListener("pageshow", (event) => {
    if (!event || !event.persisted) return;
    document
      .querySelectorAll("header-search #search-form.open, #search-form.open")
      .forEach((panel) => closeMobileSearch(panel));
  });

  return {
    init: function () {
      document.querySelectorAll(
        "#search_mini_form_header, #search_mini_form_drawer, #search_mini_form_popup"
      ).forEach(bindPredictiveForm);
      bindMobileSearch();
      bindMobileSearchViewportCleanup();
    }
  };
})();
BlsSearchShopify.init();
document.querySelectorAll("header-search").forEach((host) => {
  host.dataset.vskloSearchHostReady = "true";
});

class HeaderSearch extends HTMLElement {
  connectedCallback() {
    if (this.dataset.vskloSearchHostReady === "true") return;
    this.dataset.vskloSearchHostReady = "true";
    BlsSearchShopify.init();
  }
}

customElements.define("header-search", HeaderSearch);
class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.updateTimer = null;

    if (!this.input) return;

    this.input.addEventListener("change", this.onInputChange.bind(this));

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    if (!this.input) return;

    this.validateQtyRules();

    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }

    if (this.updateTimer) {
      clearTimeout(this.updateTimer);
    }
  }

  onInputChange() {
    /*
      Cart ownership rule:
      quantity-input НЕ має сам робити cart/change.js.
      Він тільки змінює input і віддає change в CartNotification.
      Інакше minicart отримує 2 запити: один з theme.js, другий з cart-components.js.
      Через це + / - могли виглядати як видалення.
    */
    if (!this.input) return;
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.input) return;


    const button = event.target.closest("button");
    if (!button) return;

    const previousValue = parseInt(this.input.value || "0", 10);

    if (button.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }

    const newValue = Math.max(0, parseInt(this.input.value || "0", 10));

    if (previousValue !== newValue) {
      this.input.setAttribute("data-value", String(previousValue));
      this.validateQtyRules();

      clearTimeout(this.updateTimer);

      this.updateTimer = setTimeout(() => {
        this.input.dispatchEvent(this.changeEvent);
      }, 240);
    }
  }

  validateQtyRules() {
    if (!this.input) return;

    const value = parseInt(this.input.value || "0", 10);

    const buttonMinus = this.querySelector(".quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".quantity__button[name='plus']");

    if (this.input.min && buttonMinus) {
      const min = parseInt(this.input.min, 10);
      buttonMinus.classList.toggle("disabled", value <= min);
    }

    if (this.input.max && buttonPlus) {
      const max = parseInt(this.input.max, 10);
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    const orders = this.dataset.order;
    this.init(orders);
  }
  init(orders) {
    const fe_unavaiable = this.dataset.feUnavaiable;
    const fe_avaiable = this.dataset.feAvaiable;
    const rate = Number(Shopify.currency.rate);
    const min = Number(this.dataset.feAmount);
    if (!min || !rate) return;
    const order = Number(orders) / 100;
    const min_by_currency = min * rate;
    if (order == undefined) return;
    if ((order / min_by_currency) * 100 > 100) {
      this.setProgressBar(100);
    } else {
      this.setProgressBar((order / min_by_currency) * 100);
    }
    this.setProgressBarTitle(
      order,
      min_by_currency,
      fe_unavaiable,
      fe_avaiable
    );
  }
  setProgressBarTitle(order, min_by_currency, fe_unavaiable, fe_avaiable) {
    const title = this.querySelector(".free-shipping-message");
    if (!title) return;
    title.classList.remove("opacity-0");
    if (order >= min_by_currency) {
      title.innerHTML = fe_avaiable;
    } else {
      const ammount = "{{ amount }}";
      title.innerHTML = fe_unavaiable.replace(
        ammount.trim(),
        Shopify.formatMoney(
          (min_by_currency - order) * 100,
          cartStrings.money_format
        )
      );
    }
  }
  setProgressBar(progress) {
    const p = this.querySelector(".progress");
    p.style.width = progress + "%";
    if (progress === 100) {
      this.classList.add("cart_shipping_free");
    } else {
      this.classList.remove("cart_shipping_free");
    }
  }
}
customElements.define("free-ship-progress-bar", ProgressBar);

class OpenChildrenToggle extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onToggle.bind(this), false);
  }
  onToggle() {
    const parent = this.parentElement;
    if (parent) {
      if (!parent.classList.contains("is-open")) {
        parent.classList.add("is-open");
      } else {
        parent.classList.remove("is-open");
      }
    }
  }
}
customElements.define("open-children-toggle", OpenChildrenToggle);

class CloseMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClose.bind(this), false);
  }
  onClose() {
    document.querySelector(".nav-toggle")?.classList.remove("open");
    document.querySelectorAll("menu-item").forEach((item) => {
      item.classList.remove("is-open");
    });
    document.documentElement.classList.remove("nav-open");
    window.VSKLOOverlayState?.release?.("desktop-nav");
    setTimeout(() => {
      if (window.VSKLOCleanupSharedDrawerShell) window.VSKLOCleanupSharedDrawerShell();
      else {
        document.documentElement.classList.remove("open-drawer");
        root.style.removeProperty("padding-right");
      }
    }, 400);
  }
}
customElements.define("close-menu", CloseMenu);

/* VSKLO perf: review-card runtime loads only where review-product markup exists. */
window.vskloEnsureReviewProduct = window.vskloEnsureReviewProduct || function () {
  return vskloImportOnce("reviewProduct", "./theme-review-product.js");
};
function vskloMaybeLoadReviewProduct(root = document) {
  if (!root) return;
  const matches = root.matches && root.matches("review-product");
  const contains = root.querySelector && root.querySelector("review-product");
  if (matches || contains) window.vskloEnsureReviewProduct();
}
vskloMaybeLoadReviewProduct(document);

class BackMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onBackMenu.bind(this), false);
  }
  onBackMenu() {
    if (this.classList.contains("back-lv1")) {
      this.closest(".level-1")
        .querySelector("menu-item")
        .classList.remove("is-open");
    } else {
      this.closest(".level0")
        .querySelector("menu-item")
        .classList.remove("is-open");
    }
  }
}
customElements.define("back-menu", BackMenu);

/* VSKLO perf: login popup runtime only loads when the login trigger exists. */
window.vskloEnsureLoginPopup = window.vskloEnsureLoginPopup || function () {
  return vskloImportOnce("loginPopup", "./theme-login-popup.js");
};
function vskloMaybeLoadLoginPopup(root = document) {
  if (!vskloRootHas(root, ".action-login-popup")) return Promise.resolve();
  return window.vskloEnsureLoginPopup().catch(function (error) {
    if (window.VSKLO_DEBUG) console.warn("[VSKLO] Login popup runtime load failed:", error);
    return null;
  });
}
vskloMaybeLoadLoginPopup(document);
document.addEventListener("pointerover", function (event) {
  var trigger = event.target?.closest?.(".action-login-popup");
  if (trigger) vskloMaybeLoadLoginPopup(trigger);
}, { capture: true, passive: true });
document.addEventListener("focusin", function (event) {
  var trigger = event.target?.closest?.(".action-login-popup");
  if (trigger) vskloMaybeLoadLoginPopup(trigger);
}, true);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector(".button-localization"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  disconnectedCallback() {
    document.body.removeEventListener("click", this.onBodyClick);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target != this && !target.closest("localization-form")) {
      this.hidePanel();
    }
  }

  hidePanel() {
    document.body.removeEventListener("click", this.onBodyClick);
    this.elements.button.classList.remove("open");
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    if (this.elements.button.classList.contains("open")) {
      this.hidePanel();
    } else {
      document.body.addEventListener("click", this.onBodyClick);
      this.elements.button.focus();
      for (var item of document.querySelectorAll(".button-localization")) {
        item.classList.remove("open");
      }
      this.elements.button.classList.add("open");
    }
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("localization-form", LocalizationForm);

class CollapsibleBlock extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    const block = _this.querySelectorAll(".collapsible-heading");
    block.forEach((event) => {
      event.addEventListener("click", (e) => {
        const target = e.currentTarget;
        const parent = target.parentElement;
        const footerContent = parent.querySelector(".collapsible-content");
        if (
          _this.closest(".collection-filter") &&
          _this
            .closest(".collection-filter")
            .classList.contains("horizontal") &&
          window.innerWidth > 1024
        ) {
          if (!_this.classList.contains("active")) {
            if (document.querySelector("collapsible-block.active")) {
              document
                .querySelector("collapsible-block.active")
                .classList.remove("active");
            }
            _this.classList.add("active");
          } else {
            _this.classList.remove("active");
          }
        } else {
          slideAnime({
            target: footerContent,
            animeType: "slideToggle",
          });
          if (!_this.classList.contains("active")) {
            _this.classList.add("active");
          } else {
            _this.classList.remove("active");
          }
        }
      });
    });
    this._vskloBodyClickHandler = this.handleBodyClick.bind(this);
    this._vskloResizeHandler = () => {
      this.actionInMobile();
    };
    this._vskloGlobalListenersBound = false;
  }

  connectedCallback() {
    if (this._vskloGlobalListenersBound) return;
    document.body.addEventListener("click", this._vskloBodyClickHandler);
    if (this.classList.contains("collection")) {
      this.actionInMobile();
      window.addEventListener("resize", this._vskloResizeHandler, { passive: true });
    }
    this._vskloGlobalListenersBound = true;
  }

  disconnectedCallback() {
    if (!this._vskloGlobalListenersBound) return;
    document.body.removeEventListener("click", this._vskloBodyClickHandler);
    if (this.classList.contains("collection")) {
      window.removeEventListener("resize", this._vskloResizeHandler);
    }
    this._vskloGlobalListenersBound = false;
  }

  actionInMobile() {
    var _this = this;
    var width = window.innerWidth;
    if (width <= 1024) {
      const footerContent = _this.querySelector(".collapsible-content");
      if (footerContent) footerContent.style.display = "block";
      _this.classList.add("active");
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target != this &&
      !target.closest("collapsible-block") &&
      document.querySelector(".collection-filter") &&
      document
        .querySelector(".collection-filter")
        .classList.contains("horizontal") &&
      window.innerWidth > 1024
    ) {
      const block = document
        .querySelector(".collection-filter")
        .querySelectorAll("collapsible-block");
      block.forEach((collapsible) => {
        collapsible.classList.remove("active");
      });
    }
  }
}
customElements.define("collapsible-block", CollapsibleBlock);


var returnMessageWhenSubmit = (function () {
  return {
    init: function () {
      this.checkUrlReturn();
    },
    checkUrlReturn: function () {
      const getUrl = window.location.href;
      if (
        getUrl.indexOf("customer_posted=true#newsletter-form") >= 1 ||
        getUrl.indexOf("customer_posted=true") >= 1
      ) {
        this.handleMessageSuccessPopup();
        setCookie("newsletter_popup", 30, 1);
        const newURL = location.href.split("?")[0];
        window.history.pushState("object", document.title, newURL);
      }

      if (
        getUrl.indexOf("contact%5Btags%5D=newsletter&form_type=customer") >= 1
      ) {
        this.handleMessageErrorPopup();
        const newURL = location.href.split("?")[0];
        window.history.pushState("object", document.title, newURL);
      }
    },

    handleMessageSuccessPopup: function () {
      const url = `${window.location.pathname}?section_id=form-message`;
      fetch(url, {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
        .then((response) => {
          if (!response.ok) throw new Error("Newsletter success message request failed: " + response.status);
          return response.text();
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const wrapper = html.querySelector(".newsletter-form__success-message-wrapper");
          if (!wrapper) throw new Error("Newsletter success message markup missing");
          showToast(wrapper.innerHTML, 3000, "modal-success");
        })
        .catch((error) => {
          console.warn("[VSKLO] Newsletter success message skipped:", error);
        });
    },

    handleMessageErrorPopup: function () {
      const url = `${window.location.pathname}?section_id=form-message`;
      fetch(url, {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
        .then((response) => {
          if (!response.ok) throw new Error("Newsletter error message request failed: " + response.status);
          return response.text();
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const wrapper = html.querySelector(".newsletter-form__error-message-wrapper");
          if (!wrapper) throw new Error("Newsletter error message markup missing");
          showToast(wrapper.innerHTML, 3000, "modal-error");
        })
        .catch((error) => {
          console.warn("[VSKLO] Newsletter error message skipped:", error);
        });
    },
  };
})();
returnMessageWhenSubmit.init();
class NavBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    document.body.classList.add("mobi-navigation-bar");
  }
}
customElements.define("mobile-navigation-bar", NavBar);

/* VSKLO perf: swatches/variants/quick-edit are a component runtime. */
window.vskloEnsureThemeVariants = window.vskloEnsureThemeVariants || function () {
  return vskloImportOnce("variants", "./theme-variants.js");
};
const vskloVariantSelector = [
  "variant-radios",
  "variant-radios-detail",
  "variant-radios-single",
  "variant-group-detail",
  "variant-radios-sticky",
  "variant-group-sticky",
  "variant-radios-quick-edit",
  "product-form-quick-edit",
  "swatch-dropdown-select-value"
].join(", ");
function vskloMaybeLoadThemeVariants(root = document) {
  if (vskloRootHas(root, vskloVariantSelector)) window.vskloEnsureThemeVariants();
}
vskloMaybeLoadThemeVariants(document);

/* VSKLO perf: bundle runtime loads only if bundle markup exists. */
window.vskloEnsureThemeBundle = window.vskloEnsureThemeBundle || function () {
  return vskloImportOnce("bundle", "./theme-bundle.js");
};
const vskloBundleSelector =
  "variant-radios-bundle, product-form-bundle, quantity-input-bundle, button-submit-bundle";
function vskloMaybeLoadThemeBundle(root = document) {
  if (vskloRootHas(root, vskloBundleSelector)) window.vskloEnsureThemeBundle();
}
vskloMaybeLoadThemeBundle(document);

/* VSKLO perf: password toggle is account/form-only. */
window.vskloEnsurePasswordToggle = window.vskloEnsurePasswordToggle || function () {
  return vskloImportOnce("passwordToggle", "./theme-password-toggle.js");
};
function vskloMaybeLoadPasswordToggle(root = document) {
  if (!vskloRootHas(root, "show-pass-word")) return Promise.resolve();
  return window.vskloEnsurePasswordToggle().catch(function (error) {
    if (window.VSKLO_DEBUG) console.warn("[VSKLO] Password toggle runtime load failed:", error);
    return null;
  });
}
vskloMaybeLoadPasswordToggle(document);

/* VSKLO perf: legacy admin code is never parsed on storefront. */
if (window.glozin_app?.mode === "admin") {
  import("./theme-admin.js");
}

/* VSKLO perf: QuickView/select-option runtime loads only when those controls exist. */
window.vskloEnsureThemeQuickView = window.vskloEnsureThemeQuickView || function () {
  return vskloImportOnce("quickview", "./theme-quickview.js");
};
function vskloMaybeLoadQuickView(root = document) {
  if (vskloRootHas(root, "button-quickview, select-option")) {
    window.vskloEnsureThemeQuickView();
  }
}
vskloMaybeLoadQuickView(document);

/* VSKLO perf: compare runtime loads only where product actions can use it. */
window.vskloEnsureThemeCompare = window.vskloEnsureThemeCompare || function () {
  return vskloImportOnce("compare", "./theme-compare.js");
};
function vskloMaybeLoadCompare(root = document) {
  if (vskloRootHas(root, "button-compare")) {
    window.vskloEnsureThemeCompare();
  }
}
vskloMaybeLoadCompare(document);

/* VSKLO perf: countdown runtime loads only when countdown markup exists. */
window.vskloEnsureCountdownTimer = window.vskloEnsureCountdownTimer || function () {
  return vskloImportOnce("countdown", "./theme-countdown-timer.js");
};
function vskloMaybeLoadCountdownTimer(root = document) {
  if (vskloRootHas(root, "countdown-timer")) window.vskloEnsureCountdownTimer();
}
vskloMaybeLoadCountdownTimer(document);

/* VSKLO perf: account-only runtime. */
window.vskloEnsureAccountRuntime = window.vskloEnsureAccountRuntime || function () {
  return vskloImportOnce("account", "./theme-account.js");
};
if (window.location.pathname.includes("/account")) {
  window.vskloEnsureAccountRuntime().catch(function (error) {
    if (window.VSKLO_DEBUG) console.warn("[VSKLO] Account runtime load failed:", error);
    window.setTimeout(function () {
      window.vskloEnsureAccountRuntime().catch(function (retryError) {
        if (window.VSKLO_DEBUG) console.warn("[VSKLO] Account runtime retry failed:", retryError);
      });
    }, 1200);
  });
}

class HeaderTotalPrice extends HTMLElement {
  constructor() {
    super();
  }
  updateTotal(cart) {
    this.minicart_total = this.querySelector("[data-cart-subtotal-price]");
    if (!this.minicart_total) return;
    if (cart.total_price == undefined) return;
    const price_format = Shopify.formatMoney(
      cart.total_price,
      cartStrings?.money_format
    );
    this.minicart_total.innerHTML = price_format;
  }
}
customElements.define("header-total-price", HeaderTotalPrice);

/* VSKLO perf: count-up runtime is lazy-loaded by the canonical hydration lifecycle. */
window.vskloEnsureCountUp = window.vskloEnsureCountUp || function () {
  return vskloImportOnce("countUp", "./theme-countup.js");
};


/* Old cart drawer bridge removed. Native product-form/cart-notification owns add-to-cart. */
